import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Landmark, Gauge, Calculator, ArrowRight } from "lucide-react";

// Compact homepage teaser — surfaces the live tools and routes to the full /tools page.
const LIVE_TOOLS = [
  {
    id: "foerdermittel",
    icon: Landmark,
    url: "https://foerdermittel.daaniyalkhan.com",
  },
  { id: "valuate", icon: Gauge, url: "https://valuate.daaniyalkhan.com" },
  { id: "taxleak", icon: Calculator, url: "https://taxleak.daaniyalkhan.com" },
];

const ToolsTeaser = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" aria-labelledby="tools-teaser-title">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="bg-gradient-to-br from-[#0F1B2D] to-[#1a2d4a] rounded-3xl p-10 lg:p-14">
          <div className="max-w-3xl mb-10">
            <div className="text-sm text-[#C5A66A] uppercase tracking-wider font-semibold mb-4">
              {t("toolsPage.teaser.eyebrow")}
            </div>
            <h2
              id="tools-teaser-title"
              className="font-playfair text-3xl lg:text-4xl font-bold text-white mb-4"
            >
              {t("toolsPage.teaser.title")}
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              {t("toolsPage.teaser.subtitle")}
            </p>
          </div>

          <div className="grid gap-5 md:grid-cols-3 mb-10">
            {LIVE_TOOLS.map((tool) => {
              const Icon = tool.icon;
              return (
                <a
                  key={tool.id}
                  href={tool.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#C5A66A]/50 rounded-2xl p-6 transition-all duration-300"
                  aria-label={`${t(`toolsPage.items.${tool.id}.name`)} — ${t(
                    "toolsPage.openCta"
                  )}`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-11 h-11 rounded-lg bg-[#C5A66A]/15 flex items-center justify-center">
                      <Icon
                        size={22}
                        className="text-[#C5A66A]"
                        aria-hidden="true"
                      />
                    </div>
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-green-400">
                      <span
                        className="w-1.5 h-1.5 rounded-full bg-green-400"
                        aria-hidden="true"
                      />
                      {t("toolsPage.badgeLive")}
                    </span>
                  </div>
                  <div className="font-playfair text-xl font-bold text-white mb-1 group-hover:text-[#C5A66A] transition-colors">
                    {t(`toolsPage.items.${tool.id}.name`)}
                  </div>
                  <div className="text-sm text-gray-400 leading-relaxed">
                    {t(`toolsPage.items.${tool.id}.tagline`)}
                  </div>
                </a>
              );
            })}
          </div>

          <Link
            to="/tools"
            className="inline-flex items-center bg-[#C5A66A] text-[#0F1B2D] px-7 py-3 rounded-lg font-semibold hover:bg-[#b8966b] hover:scale-105 transition-all duration-300"
          >
            {t("toolsPage.teaser.cta")}
            <ArrowRight size={18} className="ml-2" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ToolsTeaser;
